import './YearFilter.scss';

import { Box } from "@mui/material";

import { Filter } from "../../common-components/Dropdowns/Dropdowns";

const YearFilter = ({ onYearChange }) => {
    const currentYear = new Date().getFullYear();
    const startYear = 2020;

    const options = Array.from({ length: currentYear - startYear + 1 }, (v, i) => ({
        id: (startYear + i).toString(),
        name: (startYear + i).toString(),
    }));

    const handleOptionClick = (option) => {
        onYearChange(option.id);
    };

    return (
        <Box className={"year_filter"}>
            <Filter options={options} propertyLabel={"Год"} onOptionClick={handleOptionClick}/>
        </Box>
    );
}

export default YearFilter;